import React from 'react';
import UseSeo from '../hooks/UseSeo';

export const MentionsLegales = () => {
  UseSeo({
    title: 'Mentions Légales - Spa Eclipsea',
    description: 'Mentions légales d\' Alaia Cristal Bien-être, praticienne massage et soins bien-être au Spa Eclipsea de Bessines (79000).',
    path: '/mentions-legales',
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-amber-50 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <h1 className="text-3xl font-light text-purple-900 mb-8">Mentions Légales</h1>
          
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">1. Éditeur du site</h2>
            <p className="text-gray-700 mb-2"><strong>Raison sociale :</strong> Alaia Cristal Bien-être</p>
            <p className="text-gray-700 mb-2"><strong>Forme juridique :</strong> Micro-entreprise</p>
            <p className="text-gray-700 mb-2"><strong>Nom du dirigeant :</strong> Virginie GARNIER</p>
            <p className="text-gray-700 mb-2"><strong>Adresse :</strong> 21 Rue des Charmes, 79000 Bessines, France</p>
            <p className="text-gray-700 mb-2"><strong>SIRET :</strong> 50109869300028</p>
            <p className="text-gray-700 mb-2"><strong>Email :</strong> alaia.cristalbienetre@gmail.com</p>
            <p className="text-gray-700 mb-2"><strong>Téléphone :</strong> 06.47.13.93.04</p>
            <p className="text-gray-700 mb-2"><strong>N° TVA intracommunautaire :</strong> Non assujetti (franchise en base de TVA)</p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">2. Directeur de publication</h2>
            <p className="text-gray-700">Le directeur de la publication est Virginie GARNIER, gérante de Alaia Cristal Bien-être.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">3. Hébergement du site</h2>
            <p className="text-gray-700 mb-2"><strong>Hébergeur :</strong> Vercel Inc.</p>
            <p className="text-gray-700 mb-2"><strong>Adresse :</strong> 440 N Barranca Ave #4133, Covina, CA 91723, États-Unis</p>
            <p className="text-gray-700 mb-2"><strong>Site web :</strong> <a href="https://vercel.com" target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:underline">www.vercel.com</a></p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">4. Services Firebase & Stripe</h2>
            <p className="text-gray-700 mb-4">
              Ce site utilise des services tiers pour son fonctionnement :
            </p>
            <div className="mb-4">
              <p className="text-gray-700 mb-2"><strong>Firebase (Google LLC) :</strong></p>
              <p className="text-gray-700 mb-1">- Authentification des utilisateurs</p>
              <p className="text-gray-700 mb-1">- Base de données Firestore</p>
              <p className="text-gray-700 mb-2">- Adresse : 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA</p>
            </div>
            <div>
              <p className="text-gray-700 mb-2"><strong>Stripe Inc. :</strong></p>
              <p className="text-gray-700 mb-1">- Traitement sécurisé des paiements en ligne</p>
              <p className="text-gray-700 mb-2">- Adresse : 510 Townsend Street, San Francisco, CA 94103, USA</p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">5. Propriété intellectuelle</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              L'ensemble du contenu de ce site (textes, images, vidéos, logos, structure du site) est la propriété exclusive 
              d'Alaia Cristal Bien-être et est protégé par le droit d'auteur français et international.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, 
              quel que soit le moyen ou le procédé utilisé, est interdite sans autorisation écrite préalable de l'éditeur.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">6. Assurance professionnelle</h2>
            <p className="text-gray-700 leading-relaxed">
              <strong>Assurance Responsabilité Civile Professionnelle :</strong><br />
              [Nom de la compagnie d'assurance]<br />
              Numéro de police : [Numéro de contrat]<br />
              Garantie territoriale : France
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">7. Limitation de responsabilité</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Les informations diffusées sur ce site sont fournies à titre indicatif. Alaia Cristal Bien-être met tout en œuvre 
              pour offrir aux visiteurs des informations fiables et vérifiées.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Toutefois, malgré tous les soins apportés, le site peut comporter des inexactitudes, des défauts de mise à jour 
              ou des erreurs. Alaia Cristal Bien-être ne saurait être tenu responsable des erreurs ou omissions, ni des dommages 
              directs ou indirects résultant de l'utilisation de ce site.
            </p>
            <p className="text-gray-700 leading-relaxed">
              L'accès au site peut être interrompu à tout moment pour des raisons de maintenance, de mise à jour ou pour toute 
              autre raison technique, sans préavis ni notification.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">8. Médiation de la consommation</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Conformément à l'article L.612-1 du Code de la consommation, il est rappelé que tout consommateur a le droit 
              de recourir gratuitement à un médiateur de la consommation en vue de la résolution amiable d'un litige l'opposant 
              à un professionnel.
            </p>
            <p className="text-gray-700 leading-relaxed">
              <strong>Médiateur compétent :</strong><br />
              [Nom du médiateur ou plateforme de médiation]<br />
              Adresse : [Adresse complète]<br />
              Site web : [URL si applicable]
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">9. Crédits</h2>
            <p className="text-gray-700 leading-relaxed">
              <strong>Conception et développement :</strong> Benjamin DUJARDIN <br />
              <strong>Photographies :</strong> [Source des images si applicable]
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export const PolitiqueConfidentialite = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-amber-50 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <h1 className="text-3xl font-light text-purple-900 mb-8">Politique de Confidentialité (RGPD)</h1>
          
          <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-8">
            <p className="text-sm text-blue-900">
              <strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR')}<br />
              Cette politique de confidentialité est conforme au Règlement Général sur la Protection des Données (RGPD).
            </p>
          </div>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">1. Responsable du traitement</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Le responsable du traitement des données personnelles est :
            </p>
            <p className="text-gray-700 mb-2"><strong>Alaia Cristal Bien-être</strong></p>
            <p className="text-gray-700 mb-2">Représentée par Virginie GARNIER, gérante</p>
            <p className="text-gray-700 mb-2">Adresse : 21 Rue des Charmes, 79000 Bessines, France</p>
            <p className="text-gray-700 mb-2">Email : alaia.cristalbienetre@gmail.com</p>
            <p className="text-gray-700 mb-2">Téléphone : 06.47.13.93.04</p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">2. Données collectées</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Dans le cadre de nos services, nous collectons et traitons les données personnelles suivantes :
            </p>
            
            <div className="mb-4">
              <p className="text-gray-700 font-semibold mb-2">a) Lors de la création de compte :</p>
              <ul className="list-disc list-inside text-gray-700 space-y-1 ml-4">
                <li>Nom et prénom</li>
                <li>Adresse email</li>
                <li>Numéro de téléphone</li>
                <li>Mot de passe (chiffré)</li>
              </ul>
            </div>

            <div className="mb-4">
              <p className="text-gray-700 font-semibold mb-2">b) Lors de la réservation :</p>
              <ul className="list-disc list-inside text-gray-700 space-y-1 ml-4">
                <li>Date et heure du rendez-vous</li>
                <li>Type de prestation choisie</li>
                <li>Historique des réservations</li>
              </ul>
            </div>

            <div className="mb-4">
              <p className="text-gray-700 font-semibold mb-2">c) Lors du paiement en ligne (via Stripe) :</p>
              <ul className="list-disc list-inside text-gray-700 space-y-1 ml-4">
                <li>Informations de carte bancaire (traitées uniquement par Stripe, non stockées sur nos serveurs)</li>
                <li>Montant de la transaction</li>
                <li>Date et heure du paiement</li>
              </ul>
            </div>

            <div>
              <p className="text-gray-700 font-semibold mb-2">d) Données de connexion :</p>
              <ul className="list-disc list-inside text-gray-700 space-y-1 ml-4">
                <li>Adresse IP</li>
                <li>Type de navigateur</li>
                <li>Pages visitées</li>
                <li>Date et heure de connexion</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">3. Finalités du traitement</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Vos données personnelles sont collectées et traitées pour les finalités suivantes :
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li><strong>Gestion des réservations :</strong> traitement de vos demandes de rendez-vous</li>
              <li><strong>Gestion des paiements :</strong> traitement sécurisé des paiements en ligne</li>
              <li><strong>Communication :</strong> envoi d'emails de confirmation, rappels de rendez-vous</li>
              <li><strong>Gestion de la relation client :</strong> réponse à vos demandes et réclamations</li>
              <li><strong>Respect des obligations légales :</strong> comptabilité, facturation</li>
              <li><strong>Sécurité :</strong> prévention de la fraude et sécurisation des comptes</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">4. Base légale du traitement</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Le traitement de vos données repose sur les bases légales suivantes :
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li><strong>Exécution du contrat :</strong> gestion de vos réservations et paiements</li>
              <li><strong>Obligation légale :</strong> conservation des données comptables et fiscales</li>
              <li><strong>Intérêt légitime :</strong> amélioration de nos services, prévention de la fraude</li>
              <li><strong>Consentement :</strong> envoi de newsletters (si vous y avez consenti)</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">5. Destinataires des données</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Vos données personnelles sont destinées aux personnes suivantes :
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Le personnel habilité d'Alaia Cristal Bien-être</li>
              <li>Nos sous-traitants techniques :
                <ul className="list-circle list-inside ml-6 mt-2 space-y-1">
                  <li><strong>Firebase (Google LLC) :</strong> hébergement de la base de données et authentification</li>
                  <li><strong>Stripe Inc. :</strong> traitement sécurisé des paiements</li>
                  <li><strong>Vercel Inc. :</strong> hébergement du site web</li>
                </ul>
              </li>
              <li>Les autorités légales sur demande judiciaire</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">6. Transfert de données hors UE</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Certains de nos prestataires (Firebase, Stripe, Vercel) sont situés aux États-Unis. 
              Ces transferts sont encadrés par :
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Les clauses contractuelles types approuvées par la Commission européenne</li>
              <li>Le respect du RGPD par ces prestataires</li>
              <li>Des mesures de sécurité appropriées pour protéger vos données</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">7. Durée de conservation</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Vos données sont conservées pendant les durées suivantes :
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li><strong>Données de compte :</strong> jusqu'à la suppression de votre compte + 1 an</li>
              <li><strong>Données de réservation :</strong> durée de la prestation + 3 ans (obligations comptables)</li>
              <li><strong>Données de paiement :</strong> 13 mois (lutte contre la fraude) + 10 ans (comptabilité)</li>
              <li><strong>Cookies :</strong> 13 mois maximum</li>
            </ul>
            <p className="text-gray-700 mt-4">
              Passés ces délais, vos données sont supprimées ou anonymisées.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">8. Vos droits RGPD</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Conformément au RGPD, vous disposez des droits suivants sur vos données personnelles :
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li><strong>Droit d'accès :</strong> consulter les données vous concernant</li>
              <li><strong>Droit de rectification :</strong> corriger vos données inexactes ou incomplètes</li>
              <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données</li>
              <li><strong>Droit à la limitation :</strong> limiter le traitement de vos données</li>
              <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
              <li><strong>Droit à la portabilité :</strong> récupérer vos données dans un format structuré</li>
              <li><strong>Droit de retirer votre consentement :</strong> à tout moment pour les traitements basés sur le consentement</li>
              <li><strong>Droit de définir des directives :</strong> concernant le sort de vos données après votre décès</li>
            </ul>
            <p className="text-gray-700 mt-4">
              <strong>Pour exercer ces droits :</strong><br />
              Email : alaia.cristalbienetre@gmail.com<br />
              Courrier : 21 Rue des Charmes, 79000 Bessines, France<br />
              Délai de réponse : 1 mois maximum
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">9. Sécurité des données</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données :
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Chiffrement des données sensibles (mots de passe, paiements)</li>
              <li>Protocole HTTPS pour toutes les communications</li>
              <li>Accès restreint aux données personnelles</li>
              <li>Sauvegardes régulières</li>
              <li>Surveillance et détection des intrusions</li>
              <li>Mise à jour régulière des systèmes de sécurité</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">10. Cookies et traceurs</h2>
            <p className="text-gray-700 leading-relaxed">
              Pour en savoir plus sur notre utilisation des cookies, consultez notre 
              <a href="/politique-cookies" className="text-purple-600 hover:underline font-medium"> Politique de Cookies</a>.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">11. Réclamation auprès de la CNIL</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation 
              auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL) :
            </p>
            <p className="text-gray-700">
              <strong>CNIL</strong><br />
              3 Place de Fontenoy, TSA 80715<br />
              75334 PARIS CEDEX 07<br />
              Téléphone : 01 53 73 22 22<br />
              Site web : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:underline">www.cnil.fr</a>
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">12. Modifications de la politique</h2>
            <p className="text-gray-700 leading-relaxed">
              Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. 
              Toute modification sera publiée sur cette page avec une nouvelle date de mise à jour. 
              Nous vous encourageons à consulter régulièrement cette page.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export const PolitiqueCookies = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-amber-50 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <h1 className="text-3xl font-light text-purple-900 mb-8">Politique de Cookies</h1>
          
          <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-8">
            <p className="text-sm text-blue-900">
              <strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR')}
            </p>
          </div>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">1. Qu'est-ce qu'un cookie ?</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, smartphone, tablette) 
              lors de la visite d'un site internet. Il permet de mémoriser des informations relatives à votre navigation 
              et de vous offrir une expérience personnalisée.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Les cookies ont différentes finalités : certains sont indispensables au fonctionnement du site, 
              d'autres permettent d'améliorer votre expérience ou de mesurer l'audience.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">2. Cookies utilisés sur ce site</h2>
            
            <div className="mb-6">
              <h3 className="text-lg font-semibold text-purple-700 mb-3">a) Cookies strictement nécessaires</h3>
              <p className="text-gray-700 mb-3">
                Ces cookies sont indispensables au fonctionnement du site et ne peuvent pas être désactivés.
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li><strong>Cookies de session (Firebase) :</strong> permettent de maintenir votre connexion active</li>
                <li><strong>Cookies d'authentification :</strong> gèrent votre connexion et sécurisent votre compte</li>
                <li><strong>Cookies de sécurité :</strong> protègent contre les tentatives de fraude</li>
              </ul>
            </div>

            <div className="mb-6">
              <h3 className="text-lg font-semibold text-purple-700 mb-3">b) Cookies de préférence</h3>
              <p className="text-gray-700 mb-3">
                Ces cookies mémorisent vos choix pour améliorer votre expérience.
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li><strong>Préférences de langue :</strong> mémorisent votre langue préférée</li>
                <li><strong>Préférences d'affichage :</strong> retiennent vos paramètres d'affichage</li>
              </ul>
            </div>

            <div className="mb-6">
              <h3 className="text-lg font-semibold text-purple-700 mb-3">c) Cookies de paiement (Stripe)</h3>
              <p className="text-gray-700 mb-3">
                Stripe utilise des cookies pour sécuriser les transactions et prévenir la fraude.
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li><strong>Cookies de sécurité :</strong> préviennent les transactions frauduleuses</li>
                <li><strong>Cookies de session :</strong> maintiennent le contexte de paiement</li>
              </ul>
            </div>

            <div className="bg-green-50 border-l-4 border-green-500 p-4">
              <p className="text-sm text-green-900">
                <strong>✓ Nous n'utilisons PAS :</strong>
              </p>
              <ul className="list-disc list-inside text-sm text-green-800 mt-2 space-y-1">
                <li>Cookies publicitaires</li>
                <li>Cookies de tracking tiers</li>
                <li>Cookies de réseaux sociaux</li>
                <li>Cookies de ciblage marketing</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">3. Durée de conservation des cookies</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li><strong>Cookies de session :</strong> supprimés à la fermeture du navigateur</li>
              <li><strong>Cookies persistants :</strong> maximum 13 mois conformément aux recommandations de la CNIL</li>
              <li><strong>Cookies de préférence :</strong> jusqu'à 12 mois</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">4. Gestion et suppression des cookies</h2>
            
            <p className="text-gray-700 mb-4">
              Vous pouvez à tout moment choisir de désactiver ces cookies. Votre navigateur peut également être 
              paramétré pour vous signaler les cookies déposés et vous demander de les accepter ou non.
            </p>

            <div className="mb-6">
              <h3 className="text-lg font-semibold text-purple-700 mb-3">a) Configuration par navigateur</h3>
              <p className="text-gray-700 mb-4">
                Voici les liens pour configurer les cookies selon votre navigateur :
              </p>
              <ul className="space-y-3">
                <li>
                  <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" 
                     className="text-purple-600 hover:underline font-medium">
                    → Google Chrome
                  </a>
                </li>
                <li>
                  <a href="https://support.mozilla.org/fr/kb/activer-desactiver-cookies" target="_blank" rel="noopener noreferrer" 
                     className="text-purple-600 hover:underline font-medium">
                    → Mozilla Firefox
                  </a>
                </li>
                <li>
                  <a href="https://support.apple.com/fr-fr/HT201265" target="_blank" rel="noopener noreferrer" 
                     className="text-purple-600 hover:underline font-medium">
                    → Safari (Mac, iPhone, iPad)
                  </a>
                </li>
                <li>
                  <a href="https://support.microsoft.com/fr-fr/windows/supprimer-et-gérer-les-cookies-168dab11-0753-043d-7c16-ede5947fc64d" 
                     target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:underline font-medium">
                    → Microsoft Edge
                  </a>
                </li>
                <li>
                  <a href="https://help.opera.com/en/latest/web-preferences/#cookies" target="_blank" rel="noopener noreferrer" 
                     className="text-purple-600 hover:underline font-medium">
                    → Opera
                  </a>
                </li>
              </ul>
            </div>

            <div className="bg-amber-50 border-l-4 border-amber-500 p-4">
              <p className="text-sm text-amber-900">
                <strong>⚠️ Attention :</strong> La désactivation des cookies strictement nécessaires peut affecter 
                le fonctionnement du site et certaines fonctionnalités ne seront plus accessibles (connexion, réservation, paiement).
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">5. Cookies tiers</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Certains cookies sont déposés par des services tiers :
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li><strong>Firebase (Google) :</strong> authentification et base de données - 
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:underline ml-1">
                  Politique de confidentialité Google
                </a>
              </li>
              <li><strong>Stripe :</strong> traitement des paiements - 
                <a href="https://stripe.com/fr/privacy" target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:underline ml-1">
                  Politique de confidentialité Stripe
                </a>
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">6. Modifications de la politique</h2>
            <p className="text-gray-700 leading-relaxed">
              Nous nous réservons le droit de modifier cette politique de cookies à tout moment. 
              Toute modification sera publiée sur cette page avec indication de la date de mise à jour.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">7. Contact</h2>
            <p className="text-gray-700 leading-relaxed">
              Pour toute question concernant notre utilisation des cookies, contactez-nous :<br />
              Email : alaia.cristalbienetre@gmail.com<br />
              Téléphone : 06.47.13.93.04
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export const CGV = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-amber-50 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <h1 className="text-3xl font-light text-purple-900 mb-8">Conditions Générales de Vente</h1>
          
          <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-8">
            <p className="text-sm text-blue-900">
              <strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR')}<br />
              En vigueur au {new Date().toLocaleDateString('fr-FR')}
            </p>
          </div>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">Article 1 - Champ d'application</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles entre 
              Alaia Cristal Bien-être, micro-entreprise située au 21 Rue des Charmes, 79000 Bessines (ci-après "le Prestataire") 
              et toute personne physique souhaitant bénéficier des prestations de bien-être proposées (ci-après "le Client").
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Les prestations proposées sont des massages de bien-être et soins esthétiques, réalisés 
              <strong> sans visée thérapeutique, médicale ou sexuelle</strong>.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Le fait de réserver une prestation implique l'acceptation sans réserve des présentes CGV par le Client.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">Article 2 - Prestations proposées</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Le Prestataire propose des prestations de bien-être incluant :
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Soins visage et rituels minéraux</li>
              <li>Massages du monde (Lomi Lomi, Suédois, Balinais, etc.)</li>
              <li>Massages énergétiques et éveil des sens</li>
              <li>Rituels du corps et gommages</li>
              <li>Forfaits et collections de massages</li>
              <li>Cartes cadeaux</li>
            </ul>
            <p className="text-gray-700 mt-4">
              Les prestations, leurs durées et tarifs sont détaillés sur le site internet 
              et peuvent être modifiés à tout moment sans préavis.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">Article 3 - Modalités de réservation</h2>
            
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-purple-700 mb-2">3.1 Réservation en ligne</h3>
              <p className="text-gray-700 leading-relaxed">
                Les réservations peuvent être effectuées :
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-1 mt-2 ml-4">
                <li>Via le formulaire de réservation en ligne</li>
                <li>Par téléphone au 06.47.13.93.04</li>
              </ul>
            </div>

            <div className="mb-4">
              <h3 className="text-lg font-semibold text-purple-700 mb-2">3.2 Confirmation</h3>
              <p className="text-gray-700 leading-relaxed">
                Toute réservation est confirmée par email. Le Client doit vérifier l'exactitude des informations 
                (date, heure, prestation). Toute erreur doit être signalée immédiatement.
              </p>
            </div>

            <div className="mb-4">
              <h3 className="text-lg font-semibold text-purple-700 mb-2">3.3 Création de compte</h3>
              <p className="text-gray-700 leading-relaxed">
                La réservation en ligne nécessite la création d'un compte client. Le Client s'engage à fournir 
                des informations exactes et à les maintenir à jour. Il est seul responsable de la confidentialité 
                de ses identifiants de connexion.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">Article 4 - Tarifs</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Les tarifs des prestations sont indiqués en euros TTC (Toutes Taxes Comprises). 
              Le Prestataire bénéficiant de la franchise en base de TVA, les prix affichés sont hors TVA.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Les tarifs sont ceux en vigueur au jour de la réservation. Le Prestataire se réserve le droit 
              de modifier ses tarifs à tout moment, mais les prestations seront facturées sur la base des tarifs 
              en vigueur au moment de la réservation.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Les tarifs incluent la prestation elle-même mais n'incluent pas les éventuels produits complémentaires 
              qui pourront être proposés séparément.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">Article 5 - Modalités de paiement</h2>
            
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-purple-700 mb-2">5.1 Paiement en ligne</h3>
              <p className="text-gray-700 leading-relaxed mb-2">
                Le Client peut régler sa prestation en ligne via la plateforme de paiement sécurisée Stripe. 
                Deux options sont proposées :
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li><strong>Accompte de 20% :</strong> pour confirmer la réservation, le solde étant réglé sur place</li>
                <li><strong>Paiement intégral :</strong> le montant total de la prestation</li>
              </ul>
              <p className="text-gray-700 mt-3">
                Le paiement en ligne est sécurisé par Stripe. Les informations de carte bancaire ne sont pas 
                stockées sur nos serveurs.
              </p>
            </div>

            <div className="mb-4">
              <h3 className="text-lg font-semibold text-purple-700 mb-2">5.2 Paiement sur place</h3>
              <p className="text-gray-700 leading-relaxed">
                Le règlement sur place peut s'effectuer par :
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-1 mt-2 ml-4">
                <li>Carte bancaire</li>
                <li>Espèces</li>
                <li>Chèque (à l'ordre d'Alaia Cristal Bien-être)</li>
              </ul>
            </div>

            <div className="mb-4">
              <h3 className="text-lg font-semibold text-purple-700 mb-2">5.3 Forfaits et cartes cadeaux</h3>
              <p className="text-gray-700 leading-relaxed">
                Les forfaits et cartes cadeaux doivent être réglés intégralement au moment de l'achat. 
                Ils ne sont ni remboursables ni échangeables contre leur valeur monétaire.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">Article 6 - Annulation et modification</h2>
            
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-purple-700 mb-2">6.1 Annulation par le Client</h3>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li><strong>Plus de 48 heures avant :</strong> annulation gratuite avec remboursement intégral 
                    de l'accompte ou du montant versé</li>
                <li><strong>Moins de 48 heures avant :</strong> l'accompte est conservé (20% du montant) ou 
                    facturation de 50% du montant total si paiement intégral</li>
                <li><strong>Absence sans annulation :</strong> facturation de 100% du montant de la prestation</li>
              </ul>
            </div>

            <div className="mb-4">
              <h3 className="text-lg font-semibold text-purple-700 mb-2">6.2 Modification de rendez-vous</h3>
              <p className="text-gray-700 leading-relaxed">
                Une modification de rendez-vous peut être effectuée gratuitement jusqu'à 48 heures avant, 
                sous réserve de disponibilités. Passé ce délai, les conditions d'annulation s'appliquent.
              </p>
            </div>

            <div className="mb-4">
              <h3 className="text-lg font-semibold text-purple-700 mb-2">6.3 Annulation par le Prestataire</h3>
              <p className="text-gray-700 leading-relaxed">
                En cas d'annulation par le Prestataire (maladie, cas de force majeure), le Client sera 
                remboursé intégralement ou pourra reporter son rendez-vous à une date ultérieure.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">Article 7 - Droit de rétractation</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation ne peut 
              être exercé pour les prestations de services pleinement exécutées avant la fin du délai de 
              rétractation et dont l'exécution a commencé avec l'accord préalable exprès du consommateur.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Les prestations étant fixées à une date et heure précises, le Client renonce expressément 
              à son droit de rétractation dès la confirmation de sa réservation.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">Article 8 - Forfaits et cartes cadeaux</h2>
            
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-purple-700 mb-2">8.1 Validité</h3>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li><strong>Forfaits 3 séances :</strong> valables 4 mois à compter de la première utilisation</li>
                <li><strong>Forfaits 6 séances :</strong> valables 7 mois à compter de la première utilisation</li>
                <li><strong>Forfaits 10 séances :</strong> valables 12 mois à compter de la première utilisation</li>
                <li><strong>Cartes cadeaux :</strong> valables 6 mois à compter de la date d'achat</li>
              </ul>
            </div>

            <div className="mb-4">
              <h3 className="text-lg font-semibold text-purple-700 mb-2">8.2 Conditions d'utilisation</h3>
              <p className="text-gray-700 leading-relaxed">
                Les forfaits et cartes cadeaux ne sont ni remboursables, ni échangeables contre leur valeur 
                monétaire. Aucune prolongation de validité ne sera accordée passé le délai indiqué.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">Article 9 - Contre-indications et informations médicales</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Le Client s'engage à informer le Prestataire de toute contre-indication médicale pouvant 
              empêcher ou limiter la réalisation de la prestation, notamment :
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Problèmes cardiaques, hypertension</li>
              <li>Troubles circulatoires (varices, phlébite, thrombose)</li>
              <li>Maladies de peau, lésions cutanées</li>
              <li>Grossesse</li>
              <li>Interventions chirurgicales récentes</li>
              <li>Traitements médicaux en cours</li>
              <li>Allergies connues</li>
            </ul>
            <p className="text-gray-700 mt-4">
              <strong>Important :</strong> Les massages de bien-être ne se substituent en aucun cas à un 
              diagnostic, traitement ou suivi médical. En cas de doute, consultez votre médecin avant toute réservation.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">Article 10 - Responsabilité</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Le Prestataire met tout en œuvre pour assurer la meilleure qualité de service. Toutefois, 
              sa responsabilité ne saurait être engagée :
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>En cas de non-respect par le Client des contre-indications ou de déclaration erronée 
                  concernant son état de santé</li>
              <li>En cas de force majeure ou événement indépendant de sa volonté</li>
              <li>Pour les effets secondaires imprévisibles liés à la sensibilité particulière du Client</li>
              <li>En cas de vol ou perte d'objets personnels durant la prestation</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">Article 11 - Données personnelles</h2>
            <p className="text-gray-700 leading-relaxed">
              Les données personnelles collectées sont traitées conformément au RGPD. 
              Pour plus d'informations, consultez notre 
              <a href="/politique-confidentialite" className="text-purple-600 hover:underline font-medium"> Politique de Confidentialité</a>.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">Article 12 - Médiation</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Conformément à l'article L.612-1 du Code de la consommation, le Client peut recourir 
              gratuitement à un médiateur de la consommation en vue de la résolution amiable d'un litige.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">Article 13 - Droit applicable et juridiction</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Les présentes CGV sont soumises au droit français. La langue du contrat est le français.
            </p>
            <p className="text-gray-700 leading-relaxed">
              En cas de litige, une solution amiable sera recherchée avant toute action judiciaire. 
              À défaut d'accord amiable, le litige sera porté devant les tribunaux compétents 
              conformément aux règles de droit commun.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-purple-800 mb-4">Article 14 - Modifications des CGV</h2>
            <p className="text-gray-700 leading-relaxed">
              Le Prestataire se réserve le droit de modifier les présentes CGV à tout moment. 
              Les CGV applicables sont celles en vigueur à la date de la réservation.
            </p>
          </section>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-gray-600 text-sm">
              <strong>Contact :</strong><br />
              Alaia Cristal Bien-être<br />
              21 Rue des Charmes, 79000 Bessines<br />
              Email : alaia.cristalbienetre@gmail.com<br />
              Téléphone : 06.47.13.93.04
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};